module.exports = __webpack_public_path__ + "static/media/forbidden.d35443fd.ico";